import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../_metronic/helpers'
import {API_URL} from '../../../../tenant/apiBase'
import {
  SupplierUser,
  UsersQueryResponse,
  UserResponse,
  PermissionsResponse,
  CreateUserRequest,
  UpdateUserRequest,
  UpdatePermissionsRequest,
  ApiResponse
} from './_models'

const USERS_URL = `${API_URL}/api/partner-portal/users`

const getUsers = (token?: string, language?: string): Promise<UsersQueryResponse> => {
  return axios
    .get(USERS_URL, {
      headers: {token: token || '', language: language || 'en'},
    })
    .then((d: AxiosResponse<UsersQueryResponse>) => d.data)
}

const getUserById = (id: ID, token?: string, language?: string): Promise<SupplierUser | undefined> => {
  return axios
    .get(`${USERS_URL}/${id}`, {
      headers: {token: token || '', language: language || 'en'},
    })
    .then((response: AxiosResponse<UserResponse>) => response.data)
    .then((response: UserResponse) => response.user)
}

const createUser = (user: CreateUserRequest, token?: string, language?: string): Promise<any> => {
  return axios
    .post(USERS_URL, user, {
      headers: {token: token || '', language: language || 'en'},
    })
    .then((response: AxiosResponse<any>) => response.data)
}

const updateUser = (id: ID, user: UpdateUserRequest, token?: string, language?: string): Promise<SupplierUser | undefined> => {
  return axios
    .put(`${USERS_URL}/${id}`, user, {
      headers: {token: token || '', language: language || 'en'},
    })
    .then((response: AxiosResponse<ApiResponse<SupplierUser>>) => response.data)
    .then((response: ApiResponse<SupplierUser>) => response.data)
}

const deleteUser = (userId: ID, token?: string, language?: string): Promise<void> => {
  return axios.delete(`${USERS_URL}/${userId}`, {
    headers: {token: token || '', language: language || 'en'},
  }).then(() => {})
}

const deleteSelectedUsers = (userIds: Array<ID>, token?: string, language?: string): Promise<void> => {
  const requests = userIds.map((id) => axios.delete(`${USERS_URL}/${id}`, {
    headers: {token: token || '', language: language || 'en'},
  }))
  return axios.all(requests).then(() => {})
}

const getCurrentUserPermissions = (token?: string, language?: string): Promise<PermissionsResponse> => {
  return axios
    .get(`${USERS_URL}/permissions`, {
      headers: {token: token || '', language: language || 'en'},
    })
    .then((response: AxiosResponse<PermissionsResponse>) => response.data)
}

const updateUserPermissions = (id: ID, permissions: UpdatePermissionsRequest, token?: string, language?: string): Promise<void> => {
  return axios.put(`${USERS_URL}/${id}/permissions`, permissions, {
    headers: {token: token || '', language: language || 'en'},
  }).then(() => {})
}

export {
  getUsers,
  deleteUser,
  deleteSelectedUsers,
  getUserById,
  createUser,
  updateUser,
  getCurrentUserPermissions,
  updateUserPermissions
}
